<template>
  <section class="PopUp">
    <p>
      {{ $t('popup.title') }}
    </p>

    <div class="choose-country">
      <span class="flag"
        ><img
          :src="
            require('@/' + `assets/changeCountry/flag-${entity}.svg`)
          "/></span
      ><span class="country">{{ $t('popup.qwello') }} {{ country }}</span>
    </div>
    <button class="confirm-btn" @click="dispatch('confirm')">
      {{ $t('popup.confirm') }}
    </button>
    <a :href="`https://qwello.eu/${locale}/change-country`">
      <div class="change-btn">
        {{ $t('popup.change') }}
      </div>
    </a>
  </section>
</template>

<script>
import { entity } from '@/../region.json';

export default {
  name: 'ChangeCountryPopup',
  props: ['dispatch'],
  data() {
    return { entity, locale: this.$i18n.locale };
  },
  computed: {
    country() {
      return this.$i18n.t(`change_country.${this.entity.toLowerCase()}`);
    },
  },
};
</script>

<style scoped>
.PopUp {
  --width: 450px;
  --height: 310px;
  --btn-f-size: 16px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: calc(-1 * (var(--height) / 2));
  margin-left: calc(-1 * (var(--width) / 2));
  height: var(--height);
  width: var(--width);
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 21px;
  z-index: 100;
}
.confirm-btn {
  display: grid;
  place-items: center;
  margin-top: 40px;
  background: #ffdf22;
  box-shadow: 0px 3px 6px #00000029;
  color: #2b4047;
  cursor: pointer;
  height: 42px;
  text-align: center;
  width: 200px;
  border-radius: 30px;
  border: 0;
  font-size: var(--btn-f-size);
}
.change-btn {
  margin-top: 22px;
  color: #e0c420;
  font-size: var(--btn-f-size);
}
.choose-country {
  margin-top: 20px;
  display: grid;
  grid-template-columns: auto 15px 1fr;
  align-items: center;
  cursor: pointer;
}
.flag {
  grid-column: 1;
}
.flag img {
  min-width: 30px;
}
.country {
  grid-column: 3;
  color: #2b4047;
}
</style>
